<script setup lang="ts">
interface Props {
  subtitle?: boolean
}

//#region define
const props = withDefaults(defineProps<Props>(), {
  subtitle: false,
});
//#endregion
</script>

<template>
  <div class="ui-toolbar">
    <div class="ui-toolbar__block">
      <div
        v-if="$slots.title"
        class="ui-toolbar__title"
        :class="{'ui-toolbar__title_subtitle': props.subtitle}"
      >
        <slot name="title" />
      </div>
      <div
        class="t:space-x-8 t:flex t:items-center"
      >
        <slot name="left-slot" />
      </div>
    </div>
    <div class="ui-toolbar__block">
      <div class="t:space-x-8 t:flex t:items-center">
        <slot name="right-slot" />
      </div>
      <div
        v-if="$slots.actions"
        class="ui-toolbar__actions t:flex t:space-x-8"
      >
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.ui-toolbar {
  margin: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &__block {
    display: flex;
    align-items: center;
  }
  &__title{
    font-size: 24px;
    line-height: normal;
    font-weight: 500;
    color: var(--text-body);
    margin-right: 16px;
    &_subtitle {
      font-size: 20px;
      font-weight: 400;
    }
  }
  &__actions {
    margin-left: 16px;
  }
}
</style>
